export default "__VITE_ASSET__D4cAfp80__"